"use strict";
exports.__esModule = true;
exports.PlatformSaleCatalogBuilder = exports.PlatformSaleCatalog = void 0;
var PricingCatalog_1 = require("../base/PricingCatalog");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var PlatformSaleCatalog = /** @class */ (function () {
    function PlatformSaleCatalog() {
    }
    PlatformSaleCatalog.isPublished = function (catalog) {
        return PlatformSaleCatalog.isReadOnly(catalog);
    };
    PlatformSaleCatalog.isReadOnly = function (catalog) {
        return (catalog.publishedAt !== undefined) && (catalog.publishedAt !== null);
    };
    return PlatformSaleCatalog;
}());
exports.PlatformSaleCatalog = PlatformSaleCatalog;
var PlatformSaleCatalogBuilder = /** @class */ (function () {
    function PlatformSaleCatalogBuilder(platformSaleCatalog) {
        this.platformSaleCatalog = platformSaleCatalog;
    }
    PlatformSaleCatalogBuilder.initialiseWithPlatformSaleCatalog = function (platformSaleCatalog) {
        return new PlatformSaleCatalogBuilder(platformSaleCatalog);
    };
    PlatformSaleCatalogBuilder.initialise = function (name, description, deliveryUnitSaleCatalogId, platformAssetCatalog, platformSellingPricingCatalogs, merchantReferenceRetailPricingCatalogs) {
        return PlatformSaleCatalogBuilder.initialiseWithPlatformSaleCatalog({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            name: name,
            description: description,
            deliveryUnitSaleCatalogId: deliveryUnitSaleCatalogId,
            platformAssetCatalog: platformAssetCatalog,
            platformSellingPricingCatalogs: platformSellingPricingCatalogs,
            merchantReferenceRetailPricingCatalogs: merchantReferenceRetailPricingCatalogs,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    PlatformSaleCatalogBuilder.prototype.build = function () {
        return this.platformSaleCatalog;
    };
    PlatformSaleCatalogBuilder.prototype.buildUpdate = function () {
        return {
            name: this.platformSaleCatalog.name,
            description: this.platformSaleCatalog.description,
            deliveryUnitSaleCatalogId: this.platformSaleCatalog.deliveryUnitSaleCatalogId,
            platformAssetCatalog: this.platformSaleCatalog.platformAssetCatalog,
            platformSellingPricingCatalogs: this.platformSaleCatalog.platformSellingPricingCatalogs,
            merchantReferenceRetailPricingCatalogs: this.platformSaleCatalog.merchantReferenceRetailPricingCatalogs,
            publishedAt: this.platformSaleCatalog.publishedAt
        };
    };
    PlatformSaleCatalogBuilder.prototype.getId = function () {
        return this.platformSaleCatalog.id;
    };
    PlatformSaleCatalogBuilder.prototype.withId = function (id) {
        this.platformSaleCatalog.id = id;
        return this;
    };
    PlatformSaleCatalogBuilder.prototype.withName = function (newName) {
        this.platformSaleCatalog.name = newName;
        return this;
    };
    PlatformSaleCatalogBuilder.prototype.withDescription = function (newDescription) {
        this.platformSaleCatalog.description = newDescription;
        return this;
    };
    PlatformSaleCatalogBuilder.prototype.withDeliveryUnitSaleCatalogId = function (deliveryUnitSaleCatalogId) {
        this.platformSaleCatalog.deliveryUnitSaleCatalogId = deliveryUnitSaleCatalogId;
        return this;
    };
    PlatformSaleCatalogBuilder.prototype.withPlatformAssetCatalog = function (platformAssetCatalog) {
        this.platformSaleCatalog.platformAssetCatalog = platformAssetCatalog;
        return this;
    };
    PlatformSaleCatalogBuilder.prototype.withPlatformSellingPricingCatalogs = function (platformSellingPricingCatalogs) {
        this.platformSaleCatalog.platformSellingPricingCatalogs = platformSellingPricingCatalogs;
        return this;
    };
    PlatformSaleCatalogBuilder.prototype.withMerchantReferenceRetailPricingCatalogs = function (merchantReferenceRetailPricingCatalogs) {
        this.platformSaleCatalog.merchantReferenceRetailPricingCatalogs = merchantReferenceRetailPricingCatalogs;
        return this;
    };
    PlatformSaleCatalogBuilder.prototype.replacePlatformSellingPricingAccessoryPricingByCurrency = function (newAccessoryPrices) {
        this.platformSaleCatalog.platformSellingPricingCatalogs = PricingCatalog_1.PricingCatalog.replaceAccessoryPricingByCurrencyInCatalogs(this.platformSaleCatalog.platformSellingPricingCatalogs, newAccessoryPrices);
        return this;
    };
    PlatformSaleCatalogBuilder.prototype.replacePlatformSellingPricingPiecePricingByCurrency = function (newPiecePrices) {
        this.platformSaleCatalog.platformSellingPricingCatalogs = PricingCatalog_1.PricingCatalog.replacePiecePricingByCurrencyInCatalogs(this.platformSaleCatalog.platformSellingPricingCatalogs, newPiecePrices);
        return this;
    };
    PlatformSaleCatalogBuilder.prototype.replaceMerchantReferenceRetailPricingAccessoryPricingByCurrency = function (newAccessoryPrices) {
        this.platformSaleCatalog.merchantReferenceRetailPricingCatalogs = PricingCatalog_1.PricingCatalog.replaceAccessoryPricingByCurrencyInCatalogs(this.platformSaleCatalog.merchantReferenceRetailPricingCatalogs, newAccessoryPrices);
        return this;
    };
    PlatformSaleCatalogBuilder.prototype.replaceMerchantReferenceRetailPricingPiecePricingByCurrency = function (newPiecePrices) {
        this.platformSaleCatalog.merchantReferenceRetailPricingCatalogs = PricingCatalog_1.PricingCatalog.replacePiecePricingByCurrencyInCatalogs(this.platformSaleCatalog.merchantReferenceRetailPricingCatalogs, newPiecePrices);
        return this;
    };
    PlatformSaleCatalogBuilder.prototype.withPublishedAt = function (publishedAt) {
        this.platformSaleCatalog.publishedAt = publishedAt;
        return this;
    };
    PlatformSaleCatalogBuilder.prototype.withNotPublishedAt = function () {
        return this.withPublishedAt(undefined);
    };
    return PlatformSaleCatalogBuilder;
}());
exports.PlatformSaleCatalogBuilder = PlatformSaleCatalogBuilder;
